import React, { useState } from 'react';

import { useParams } from "react-router-dom";
import Loader from 'react-loader-spinner';
import { useList } from '../hooks/listHook';
import EmptyList from '../useful/EmptyList';
import NotFound from '../useful/NotFound';
import { withAuthorization } from '../session';
import Modal from 'react-modal';
import { modalStyle } from '../styles/modal';
import { useItem } from '../hooks/itemHook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMale, faFemale, faRestroom } from '@fortawesome/free-solid-svg-icons';

import data from '../../constants/tournament.json';
import TournamentLoader from '../loaders/TournamentLoader';
import TeamList from '../TeamList/TeamsList'
import Matches from '../Matches/Matches';
import Classification from '../classification/Classification';
import ModalInfo from '../useful/ModalInfo';
import TournamentData from './TournamentData';
import Statistics from '../statistics/Statistics';

const TournamentPage = (props) => {

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { loading: loadingItem, item: tournament } = useItem(props.firebase.tournamentDoc(userId, tournament_uid), tournament_uid);
    const { loading: loadingTeams, list: teams } = useList(props.firebase.teamList(userId, tournament_uid), tournament_uid);
    const { loading: loadingPlayers, list: players } = useList(props.firebase.playerCollection(userId, tournament_uid), tournament_uid);

    const loading = loadingItem && loadingTeams && loadingPlayers;

    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    const { _format, _type } = data;

    if (!loadingItem && tournament == null) {
        return <NotFound />
    }

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const disabled = loading ? "disabled" : "";

    let genderIcon = null;
    if (tournament)
        genderIcon = (tournament.gender == "M") ? faMale : (tournament.gender == "F") ? faFemale : faRestroom;

    return (
        <div className="bg-white border rounded-lg">

            <TournamentData loading={loadingItem} tournament={tournament} />

            <div className="container-fluid col-12 text-decoration-none p-0 mb-2 ">
                <nav className="small tabbable">
                    <div className="rounded-lg nav nav-tabs nav-fill font-weight-bold" id="nav-tab" role="tablist">
                        {/* <div className=" rounded-lg nav nav-tabs nav-fill flex-column flex-sm-row font-weight-bold" id="nav-tab" role="tablist"> */}

                        <a className={"border border-white bg-bluegray nav-item nav-link active text-dark "} id="nav-teams-tab" data-toggle="tab" href="#nav-teams" role="tab" aria-controls="nav-teams" aria-selected="false" aria-selected="true">
                            Equipos
                            </a>

                        <a className={"border border-white bg-bluegray nav-item nav-link text-dark " + disabled} id="nav-matches-tab" data-toggle="tab" href="#nav-matches" role="tab" aria-controls="nav-matches" aria-selected="false">
                            Fixture
                            </a>

                        <a className={"border border-white bg-bluegray nav-item nav-link text-dark " + disabled} id="nav-classification-tab" data-toggle="tab" href="#nav-classification" role="tab" aria-controls="nav-classification" >
                            Posiciones
                            </a>

                        <a className={"border border-white bg-bluegray nav-item nav-link text-dark " + disabled} id="nav-statistic-tab" data-toggle="tab" href="#nav-statistic" role="tab" aria-controls="nav-statistic" aria-selected="false">
                            Estadisticas
                            </a>

                    </div>
                </nav>

                <div className="tab-content p-2" id="nav-tabContent">

                    <div className="tab-pane fade show active" id="nav-teams" role="tabpanel" aria-labelledby="nav-teams-tab">
                        <TeamList loading={loading} tournament={tournament} teams={teams} />
                    </div>
                    <div className="tab-pane fade" id="nav-matches" role="tabpanel" aria-labelledby="nav-matches-tab">
                        <Matches loading={loading} tournament={tournament} teams={teams} players={players} />
                    </div>
                    <div className="tab-pane fade" id="nav-classification" role="tabpanel" aria-labelledby="nav-classification-tab">
                        <Classification loading={loading} tournament={tournament} teams={teams} />
                    </div>
                    <div className="tab-pane fade" id="nav-statistic" role="tabpanel" aria-labelledby="nav-statistic-tab">
                        <Statistics loading={loading} tournament={tournament} teams={teams} players={players} />
                    </div>


                </div>

            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(TournamentPage);